import styled from "styled-components";
import fonts from "../../../../config/fonts";
import { isMobile } from "../../../../utils/common";

export const TestimonialsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const TestimonialsHeading = styled.div`
  ${fonts.headings};
  font-size: 35px;
  padding: ${isMobile() ? "30px 30px 0px 30px" : "60px"};
  font-style: italic;
  ${
    isMobile() && `
      text-align:center;
      font-size:24px;
    `
  }
`;
export const TestimonialCarousal = styled.div`
  width: 100%;
  padding: ${isMobile()? "30px" : "100px"};
  box-sizing: border-box;
  display: flex;
  flex-direction:${isMobile()?"column":"row"};
  align-items: center;
  justify-content: space-between;
  height: 270px;
  padding-top:30px;
`;
export const LeftArrow = styled.img`
  width: 40px;
  cursor:pointer;
  opacity:0.9;
  transition: all 0.2s ease;
  :hover{
    opacity:1;
  }
`;
export const TestimonialImage = styled.img`
  position: absolute;
  width: 50vw;
  transition:opacity 0.2s ease;
  left:25vw;
  ${(props) =>
    props.visibilityState === 0 || isMobile()
      ? "opacity:1"
      : "opacity:0"};
  ${
    isMobile() && `
      width:100%;
      position:static;
      left:0px;
      margin:5px;
    `
  }
`;
export const RightArrow = styled.img`
  width: 40px;
  cursor:pointer;
  opacity:0.9;
  transition: all 0.2s ease;
  :hover{
    opacity:1;
  }
`;
